export  const  arrayToObject = (array,keyField) =>
                Object.assign({},...array.map(item => ({ [item[keyField]]:item })))
                



// WEBPACK FOOTER //
// ./src/utils/functions/arraytoobject.js